import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { supabase } from '../../lib/supabase'

export function AuthCallbackPage() {
  const navigate = useNavigate()

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (event === 'SIGNED_IN' && session) {
          navigate({ to: '/' })
        }
        if (event === 'SIGNED_OUT') {
          navigate({ to: '/login' })
        }
      }
    )
    return () => subscription.unsubscribe()
  }, [navigate])

  return (
    <div style={{
      minHeight: '100dvh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0e0f12',
      color: '#9ba1ac',
      fontFamily: '"Inter", system-ui, sans-serif',
      fontSize: 14,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{
          width: 20, height: 20, borderRadius: '50%',
          border: '2px solid oklch(0.72 0.15 260)',
          borderTopColor: 'transparent',
          animation: 'spin 0.8s linear infinite',
        }} />
        ログイン処理中...
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  )
}
